module.exports = __webpack_public_path__ + "img/minimal.3a4a2c6b.png";